import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  type IServiceCode,
  type IServiceCodeEntry,
} from '@principle-theorem/principle-core/interfaces';
import { AddServiceCodeComponent } from '../add-service-code/add-service-code.component';
import { NgDialogModule } from '@principle-theorem/ng-shared';

export interface IAddServiceCodeDialogData {
  commonCodes: IServiceCodeEntry[];
}

@Component({
  selector: 'pr-add-service-code-dialog',
  templateUrl: './add-service-code-dialog.component.html',
  styleUrls: ['./add-service-code-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, AddServiceCodeComponent],
})
export class AddServiceCodeDialogComponent implements AfterViewInit {
  @ViewChild(AddServiceCodeComponent)
  addServiceCodeComponent?: AddServiceCodeComponent;

  constructor(
    @Inject(DIALOG_DATA) public data: IAddServiceCodeDialogData,
    private dialogRef: DialogRef<IServiceCode>
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.addServiceCodeComponent?.focusInput();
    }, 100);
  }

  onCodeSelected(serviceCode: IServiceCode): void {
    this.dialogRef.close(serviceCode);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
